<template>
  <component :is="signUpFormComponent" :open="isOpen" @close="handleClose" />
</template>

<script>
import { defineAsyncComponent } from "vue";
import { mapGetters, mapActions } from "vuex";
import addDays from "date-fns/addDays";
import isAfter from "date-fns/isAfter";
import isSameDay from "date-fns/isSameDay";
import parseISO from "date-fns/parseISO";
import { getFeatureToggles } from "@/helpers/featureToggles.js";

export default {
  name: "DataCollection",
  data() {
    return {
      open: false,
      initialLoggedInValue: false,
    };
  },
  computed: {
    ...mapGetters("auth", ["isLoggedIn"]),
    ...mapGetters("app", ["dataCollectionDismissed"]),
    version() {
      const { dataCollectionVersion = 3 } = getFeatureToggles();
      return dataCollectionVersion;
    },
    signUpFormComponent() {
      return defineAsyncComponent({
        loader: () =>
          import(
            /* webpackChunkName: "[request]" */ `@/components/sign-up-forms/ModalSignUpV${this.version}.vue`
          ),
      });
    },
    isOpen: {
      get() {
        const commonCondition = !(this.dataCollectionDismissed || !this.open);

        if (this.version === "4") {
          return commonCondition;
        }

        return commonCondition && !this.initialLoggedInValue;
      },
      set(value) {
        this.open = value;
      },
    },
  },
  mounted() {
    setTimeout(() => {
      this.initialLoggedInValue = this.isLoggedIn;
      this.checkIfShouldOpen();
    }, 5 * 1000);
  },
  methods: {
    ...mapActions("app", ["setUserPreferences"]),
    handleClose() {
      this.setUserPreferences({
        key: "dataCollectionDismissed",
        value: true,
      });
    },
    checkIfShouldOpen() {
      const storedDate = localStorage.getItem("shopifyDataCollectionDate");

      if (!storedDate) {
        this.isOpen = true;
        return;
      }

      const parsedStoredDate = parseISO(storedDate);
      const currentDate = new Date();
      const oneDayAfterStoredDate = addDays(parsedStoredDate, 1);
      const isOneDayAfter =
        isAfter(currentDate, oneDayAfterStoredDate) ||
        isSameDay(currentDate, oneDayAfterStoredDate);

      this.isOpen = isOneDayAfter;
    },
  },
};
</script>
